<template>
  <div id="productCategory">
    <div class="message" v-if="ISSET_NO_SAVE_CHANGES">
      *Есть несохраненные данные*
    </div>
    <goods-top-menu></goods-top-menu>

    <b-overlay :show="showOverlay > 0" class="overlay mt-3" rounded="lg">
      <div class="category-tree">
        <vue-drag-tree :data='CATEGORY_LIST'
                       :defaultText='newCategoryName'
                       @current-node-clicked='curNodeClicked'
                       @drag="dragHandler"
                       @drop="dropHandler"
                       ref="dragTree"
        >
        </vue-drag-tree>
      </div>
      <div class="view-edit-area">
        <div v-if="CATEGORY_LIST.length > 0" class="text-align-right mb-2">
          <b-button class="float-left" v-on:click="toggleList()" variant="primary">Свернуть / Развернуть</b-button>
          <b-input class="float-left width-50-percent ml-2" v-model="search" type="text" placeholder="Поиск"
                   v-on:change="searchM()"></b-input>
          <b-button v-on:click="saveChange" variant="primary">
            <span v-if="!IS_LOAD">Сохранить</span>
            <section v-if="IS_LOAD">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Сохранение...
            </section>
          </b-button>
        </div>
        <b-card v-if="Object.keys(model).length > 0" ref="formCard">
          <b-container fluid>
            <b-row class="input-category">
              <b-col sm="2">
                <label>ID: {{ model.id }}</label>
              </b-col>
            </b-row>
            <b-row class="input-category">
              <b-col sm="2">
                <label for="input-2">Родитель:</label>
              </b-col>
              <b-col sm="10">
                <b-input id="input-2" size="sm" v-model="model.parentId"
                         v-on:change="categoryMove(model.id, model.parentId), change()"></b-input>
              </b-col>
            </b-row>
            <b-row class="input-category">
              <b-col sm="2">
                <label for="ruName">Название (ru):</label>
              </b-col>
              <b-col sm="10">
                <b-input id="ruName" size="sm" v-model="model.ruName" v-b-tooltip.hover :title="model.ruName"
                         v-on:change="changeRuName(), change()"></b-input>
              </b-col>
            </b-row>
            <b-row class="input-category" v-for="item in langList" v-bind:key="item">
              <b-col sm="2">
                <label :for="'input-'+ item">Название ({{ item }}):</label>
              </b-col>
              <b-col sm="10">
                <b-input
                    :id="'input-'+ item"
                    size="sm"
                    v-model="model[item +'Name']"
                    v-b-tooltip.hover
                    :title="model[item +'Name']"
                    v-on:change="change()"
                    :class="{'translation': model.translations !== undefined && model.translations.includes(item)}"
                ></b-input>
              </b-col>
            </b-row>
            <!--                    <b-row class="input-category">-->
            <!--                        <b-col sm="2">-->
            <!--                            <label for="input-7">Черновой вариант:</label>-->
            <!--                        </b-col>-->
            <!--                        <b-col sm="10">-->
            <!--                            <b-form-checkbox id="input-7" size="sm" v-model="model.draft" v-on:change="change()"></b-form-checkbox>-->
            <!--                        </b-col>-->
            <!--                    </b-row>-->
            <b-row class="mt-5 input-category mb-3">
              <div fluid class="width-50-percent">
                <b-button variant="primary" v-on:click="categoryAdd(model.id), change()">Создать</b-button>
              </div>
              <div fluid class="width-50-percent text-align-right">
                <b-button v-on:click="categoryDelete(model.id, CATEGORY_LIST), change()">Удалить</b-button>
              </div>
            </b-row>
            <b-row>
              <div class="flex-fill d-flex justify-content-end">
                <a
                    :href="hostApi +'/goods-category-export/'+ model.id +'/'+ getAuthToken"
                    class="btn btn-outline-danger"

                >
                  Выгрузить категории
                </a>
              </div>
            </b-row>
            <b-row v-if="isExtraCategoryExport">
              <div class="d-flex w-100 justify-content-between my-3">
                <div class="flex-fill">
                  <b-btn
                      variant="primary"
                      @click="createExport"
                      :disabled="IS_EXPORT"
                  >
                    <template v-if="IS_EXPORT">
                      <b-spinner small></b-spinner>
                      <span class="sr-only">Loading...</span>
                    </template>
                    Создать экспорт
                  </b-btn>
                </div>
                <div class="flex-fill d-flex justify-content-end">
                  <a
                      :href="hostApi +'/goods-category-export/'+ model.id +'/'+ getAuthToken"
                      class="btn btn-outline-danger"

                  >
                    Выгрузить категории
                  </a>
                </div>
              </div>
            </b-row>
            <b-row v-if="isExtraCategoryExport">
              <b-col cols="12">
                <b-link variant="primary" @click.prevent="onShowExports">
                  <template v-if="EXPORT_LIST.length">Скрыть экспорты</template>
                  <template v-if="!EXPORT_LIST.length">Показать экспорты</template>
                </b-link>
              </b-col>
              <b-col cols="12">
                <ExportItem :item="item" v-for="item in EXPORT_LIST" :key="item.id" />
              </b-col>
            </b-row>
          </b-container>
        </b-card>
        <p>&nbsp;</p>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import goodsTopMenu from '../components/topMenu';
import {createNamespacedHelpers} from "vuex";
import {config} from "@/config";
import ExportItem from "@/components/goods/category/ExportItem.vue";

const {mapGetters, mapActions} = createNamespacedHelpers('goods/category');

export default {
  name: "category",
  components: {
    ExportItem,
    goodsTopMenu
  },
  data() {
    return {
      newCategoryName: 'Новая категория',
      model: {},
      droppedId: null,
      search: '',
      flagToggleList: false,
      showOverlay: 0,
      langList: ['en', 'de', 'es', 'pt', 'it', 'fr', 'pl', 'ua', 'cs', 'hu', 'ro', 'nl', 'bg', 'mk'],
      hostApi: config.apiUrl,
      isExtraCategoryExport: false
    }
  },
  methods: {
    ...mapActions(['GET_ALL', 'SAVE', 'SEARCH_AND_DO']),
    saveChange() {
      this.SAVE({th: this});
    },
    async deactivateForm() {
      await this.$set(this, 'model', {});
    },
    curNodeClicked(model) {
      this.$store.commit('goods/category/EXPORT_LIST', [])
      this.model = model;
      if (model.name == this.newCategoryName) {
        this.model.name = model.id + ' - ' + model.name;
        this.model.ruName = this.model.name;
      }
      if (model.parentId == '') {
        this.model.parentId = 0;
      }

      // lighting of selected item
      let lightEl = this.$refs.dragTree.$el.querySelector('div[style*="background-color: rgb(0, 123, 255);"]');
      if (lightEl != null) {
        lightEl.style = '';
        lightEl.querySelector('span.text').style = '';
      }
      let el = this.$refs.dragTree.$el.querySelector('div[id="' + model.id + '"]').parentElement;
      el.style = 'background-color: #007bff;';
      el.querySelector('span.text').style = 'color: white;';
      // add focus
      if (this.$refs.formCard != undefined) {
        this.$refs.formCard.querySelector('#ruName').focus();
      }
    },
    dragHandler(model) {
      this.droppedId = model.id;
    },
    dropHandler(model) {
      this.changeParent(this.droppedId, model, this.CATEGORY_LIST);
      this.change();
    },


    changeParent: function (droppedId, parent, categoryList) {
      for (let key in categoryList) {
        if (categoryList[key].id == droppedId) {
          if (categoryList[key].parentId == parent.id) {
            categoryList[key].parentId = parent.parentId;
          } else {
            categoryList[key].parentId = parent.id;
          }
          break;
        } else {
          if (categoryList[key].children != []) {
            this.changeParent(droppedId, parent, categoryList[key].children);
          }
        }
      }
    },
    categoryDelete: function (id, list) {
      for (let key in list) {
        if (list[key].id == id) {
          if (list[key].children != []) {
            this.addToDeleteOfChildren(list[key].children);
          }
          list.splice(key, 1);
          this.DELETE_LIST.push(id);
          this.model = {};
          break;
        } else {
          if (list[key].children.length > 0) {
            this.categoryDelete(id, list[key].children);
          }
        }
      }
    },
    addToDeleteOfChildren: function (list) {
      let idList = [];
      for (let key in list) {
        idList.push(list[key].id);
        if (list[key].children != []) {
          this.addToDeleteOfChildren(list[key].children);
        }
      }

      idList.reverse();
      this.$store.commit('goods/category/DELETE_LIST', this.DELETE_LIST.concat(idList));
    },
    changeRuName: function () {
      this.model.name = this.model.id + ' - ' + this.model.ruName;
    },
    categoryMove: function (id, parentId) {
      let buf = {};
      // copy and delete
      let funcDelete = function (list, key) {
        buf = list[key];
        list.splice(key, 1);
      }
      this.SEARCH_AND_DO({id: id, func: funcDelete, cList: this.CATEGORY_LIST});
      // push to children
      let funcPush = function (list, key) {
        list[key].children.push(buf);
      }
      this.SEARCH_AND_DO({id: parentId, func: funcPush, cList: this.CATEGORY_LIST});
    },
    categoryAdd: function (id) {
      let skeleton = {
        id: this.NEW_COUNTER,
        name: this.NEW_COUNTER + ' - ' + this.newCategoryName,
        ruName: this.NEW_COUNTER + ' - ' + this.newCategoryName,
        parentId: id,
        children: [],
        level: 0
      };
      let funcVal = function (list, key) {
        if (list[key].children == undefined) {
          list[key].children = [];
        }
        list[key].children.push(skeleton);
      }
      this.SEARCH_AND_DO({id: id, func: funcVal, cList: this.CATEGORY_LIST});
      setTimeout(() => {
        let element = this.$refs.dragTree.$el.querySelector('div[id="' + (this.NEW_COUNTER - 1) + '"]');
        if (element == null) {
          return;
        }
        element.click();
        element.parentElement.parentElement.parentElement.style = '';
      }, 1);

      this.$store.commit('goods/category/NEW_COUNTER');
    },
    toggleList: function () {
      let element = this.$refs.dragTree.$el.querySelectorAll('.treeMargin');
      var th = this;

      if (th.flagToggleList) {
        element.forEach((val) => {
          val.style.display = 'none';
        });
      } else {
        element.forEach((val) => {
          val.style.display = 'block';
          let textElements = val.querySelectorAll('.text');
          if(textElements.length > 0) {
            textElements.forEach((val) => {
              val.style.display = 'block';
            })
          }
        });
      }

      this.flagToggleList = !this.flagToggleList;
    },
    searchM: function () {
      let firstTreeBlock = this.$refs.dragTree.$el.firstChild.querySelector('.treeMargin');
      firstTreeBlock.style.display = 'block';
      let element = this.$refs.dragTree.$el.querySelectorAll('.treeNodeText .text');
      element.forEach((val) => {
        val.style.display = 'block';
      });
      if (this.search == '') {
        return;
      }
      let searchRecursive = (searchWord, list) => {
        searchWord = searchWord.toLowerCase();
        let listName = [];
        for (let key in list) {
          if (
              list[key].id.toString().indexOf(searchWord) != -1 ||
              list[key].name.toLowerCase().indexOf(searchWord) != -1
          ) {
            listName.push(list[key].name.toLowerCase())
          }
          for (let key2 in list[key]) {
            if ((list[key][key2] != undefined && list[key][key2].toString().toLowerCase().indexOf(searchWord) != -1)) {
              listName.push(list[key].name.toLowerCase())
            }
          }

          if (list[key].children != undefined) {
            listName = listName.concat(searchRecursive(searchWord, list[key].children));
          }
        }
        return listName;
      };

      function findAllTreeMarginsAbove(element) {
        const result = [];
        let currentElement = element;

        while (currentElement) {
          currentElement = currentElement.parentElement;
          if (!currentElement) break;
          if (currentElement.classList.contains("treeMargin")) {
            result.push(currentElement);
          }
        }

        return result;
      }

      let findName = searchRecursive(this.search, this.CATEGORY_LIST);

      let scrolledToFirst = false;
      element.forEach((val) => {
        if (findName.indexOf(val.innerText.toLowerCase()) == -1) {
          val.style.display = 'none';
        } else {
          let treeMarginsAbove = findAllTreeMarginsAbove(val);
          if (treeMarginsAbove.length > 0) {
            treeMarginsAbove.forEach((val) => {
              val.style.display = 'block';
            })
          }
          if (!scrolledToFirst) {
            val.scrollIntoView({ behavior: 'smooth', block: 'center' });
            scrolledToFirst = true;
          }
        }
      });
    },
    change: function () {
      console.log('change');
      this.$store.commit('goods/category/ISSET_NO_SAVE_CHANGES', true);
      this.levelCount();
    },
    levelCount: function () {
      let counter = (item, levelCountList, levelNum) => {
        levelNum++;
        if (item.children == undefined || item.children.length == 0) {
          item.name = item.id + ' - ' + item.ruName + ' (0)';
        } else {
          let children = item.children;

          if (levelCountList[levelNum] == undefined) {
            levelCountList[levelNum] = 0;
          }
          levelCountList[levelNum] += children.length;

          children.forEach((val) => {
            if (val.children != undefined) {
              counter(val, levelCountList, levelNum);
            }
          });

          item.name = item.id + ' - ' + item.ruName + ' (' + this.levelToString(levelCountList, levelNum) + ')';
        }
      };

      let recursiveRun = (item) => {
        if (item == undefined) {
          return;
        }
        let levelCountList = {};
        let levelNum = 0;
        counter(item, levelCountList, levelNum);
        if (item.children != undefined && item.children.length > 0) {
          item.children.forEach((val) => {
            recursiveRun(val);
          });
        }
      }

      recursiveRun(this.CATEGORY_LIST[0]);
    },
    levelToString: function (levelList, levelNum) {
      let levelStr = '';
      for (let key in levelList) {
        if (key >= levelNum) {
          levelStr = levelStr + (levelStr == '' ? '' : '-') + levelList[key];
        }
      }

      return levelStr;
    },
    createExport: function () {
      let params = {
        th: this,
        category: this.model.id
      }
      this.$store.dispatch('goods/category/EXPORT', params)
    },
    onShowExports: function () {
      if (this.EXPORT_LIST.length) {
        this.$store.commit('goods/category/EXPORT_LIST', [])
      } else {
        this.$store.dispatch('goods/category/GET_EXPORTS_ALL', {category: this.model.id});
      }
    }
  },
  computed: {
    ...mapGetters(['CATEGORY_LIST', 'DELETE_LIST', 'IS_LOAD', 'NEW_COUNTER', 'ISSET_NO_SAVE_CHANGES', 'EXPORT_LIST', 'IS_EXPORT']),
    getAuthToken: function () {
      return localStorage.authToken
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('product') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    if (this.CATEGORY_LIST.length == 0) {
      this.GET_ALL({th: this});
    }
  },
  watch: {
    CATEGORY_LIST: function (val, oldVal) {
      console.log('watch');
      console.log(val);
      console.log(oldVal);

      this.levelCount();
    }
  },
  created() {
    this.unwatch = this.$store.watch(
        (state, getters) => getters.CATEGORY_LIST,
        (newValue, oldValue) => {
          console.log(`Updating from ${oldValue} to ${newValue}`);
        });
  },
  beforeDestroy() {
    this.unwatch();
  },
}
</script>

<style scoped>
.category-tree {
  width: 45%;
}

.view-edit-area {
  width: 48%;
  padding-left: 10px;
  float: right;
  text-align: left;
  position: fixed;
  right: 15px;
  top: 95px;
  bottom: 5px;
  overflow: auto;
  scrollbar-color: #6c757d #ced4da;
  scrollbar-width: thin;
}

.view-edit-area label {
  width: 8rem;
}

.view-edit-area .row {
  margin-bottom: 5px;
}

.text-align-right {
  text-align: right;
}

.width-50-percent {
  width: 50%;
}

.selected-item {
  background-color: #007bff;
}

.message {
  float: right;
  color: #155724;
  background: #d4edda;
  padding: 0.375rem 0.75rem;
  border-color: #c3e6cb;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
}

.translation {
  background-color: #FFA500;
}

#productCategory .b-overlay.position-absolute {
  top: -5px;
  right: -12px
}
</style>

<style>
#productCategory .dnd-container, #productCategory .dnd-container .is-clicked,
#productCategory .dnd-container .is-hover {
  background: #fff;
}

.category-tree span.text {
  font-size: 15px;
  font-weight: 400;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

#productCategory .b-overlay.position-absolute {
  top: -5px !important;
  right: -12px !important;
  min-height: 250px;
}
</style>